/**
 * @file
 */

import { validateSaveAccount } from "../common/validation/utils.js";



// global variables for the summary check logic
var FIELD_LABEL = 0;
var FIELD_VALUE = 1;
var FIELD_ID = 2;

var reviewValues = [];   // values populated upon initial load
var saveChanges = false;   // boolean set by modal 'OK' button processing to tell page click event to postback and save changes.

export function InitializeBankAccountControl() {
   $("[id$='divSummaryReviewDialog']").dialog({
      autoOpen: false,
      modal: true,
      resizable: false,
      width: "auto",
      dialogClass: "dlgSummaryReview",
      buttons: {
         "OK": {
            text: "OK",
            class: 'twoColorButton',
            click: function () {
               saveChanges = true;
               $("[id$='btnReviewSave']").click();
            }
         },
         "CANCEL": {
            text: "CANCEL",
            class: 'secondaryButton',
            click: function () {
               $(this).dialog("close");
            }
         }
      }
   });
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-10
  window.handleBtnReviewSaveClick = handleBtnReviewSaveClick;
};

function collectReviewValues() {
   // declare field variables for the summary check logic
   var fieldLabel = "";
   var fieldValue = "";
   var fieldID = "";

   reviewValues = [];

   // perform the summary check logic over all elements that have the class 'summaryCheck'
   // store the values of those elements in the global array reviewValues
   var addRow;
   $('.summaryCheck').each(function (index) {
      addRow = true;
      // get the id of the element, it's value, and the text of the associated label
      fieldID = $(this).attr("id");
      fieldValue = $(this).val();
      if (fieldID !== undefined) {
         if ($(this).is("select")) {
            fieldValue = $("#" + fieldID + " :selected").text();
         } else if ($(this).is("input[type=checkbox]")) {
            fieldValue = "No";
            if ($(this).is(":checked"))
               fieldValue = "Yes";
         } else if ($(this).hasClass("last4")) {
            fieldValue = $(this).val().substring($(this).val().length - 4, $(this).val().length);
         } else {
            fieldValue = $(this).val();
         }

         fieldLabel = $("label[for='" + fieldID + "']").children('span.label-text').html();
         if ($(this).hasClass("last4")) {
            fieldLabel = fieldLabel + " (Last 4 digits)"
         }

         if (fieldValue == "") {
            fieldValue = "(No Value)";
         }

         if (addRow) {
            // push those items onto a row 
            var row = [];
            row.push(fieldLabel);
            row.push(fieldValue);
            row.push(fieldID);
            // push that row onto the review Values array
            reviewValues.push(row);
         }
      }
   });

}

function displaySummaryReview() {
   var introText = $("div[id$='divSummaryReviewDialog']").attr("data-dialogTextIntro");
   var outputString = introText + "<br /><br />"
                     + "<table class='summaryReviewTable' datatable='true'>"
                     + "<colgroup><col style='width: 35%;'/><col style='width: 65%;'/></colgroup>"
                     + "<thead><tr><th style='text-align: left;'>Field</th><th style='text-align: left;'>Value</th></tr></thead><tbody>";

   for (var i = 0; i < reviewValues.length; i++) {
      outputString = outputString + "<tr><td>" + reviewValues[i][FIELD_LABEL] + "</td>"
                                 + "<td>" + reviewValues[i][FIELD_VALUE] + "</td></tr>";
   }

   var previousScreen = $("h1")[0].innerText;
   outputString = outputString + "</tbody></table><br />"
                              + "Click 'OK' to submit or 'Cancel' to return to the " + previousScreen + " page."
   $("[id$='divSummaryReviewDialogContent']").html(outputString);

   $("[id$='divSummaryReviewDialog']").dialog("open");

}

// function called for the client click.  We need to make sure validation runs prior to the summary
// check logic.  If that page validates then we call reviewSuccessful.
function handleBtnReviewSaveClick() {
   // perform the validation.  If the page validates then do the review calls to display the modal.
  if (validateSaveAccount()) {
      if (saveChanges) {
         return true;
      } else {
         collectReviewValues();
         displaySummaryReview();
         return false;
      }
   } else {
      return false;
   }
}

